import { Sort } from "@angular/material/sort";

export interface Items {
    folders: Item[];
    files: Item[];
    path: any[];
}

export interface Item {
    id?: string;
    folderId?: string;
    name?: string;
    createdBy?: string;
    createdAt?: string;
    modifiedAt?: string;
    size?: string;
    type?: string;
    contactName?: string | null;
    matterName?: string | null;
    contents?: string | null;
    description?: string | null;
    labels?: string[];
    isFolder?: Boolean;
    isStarred?: Boolean;
}
export interface ItemLabel {
    id: string;
    name: string;
    accountId: string;
    colorCode: string;
    createdBy: string;
    lastEditedBy: string;
    createdAt: string;
    lastEditedAt: string;
}

export interface ItemFilter {
    id: string;
    title: string;
    slug: string;
    icon: string;
}

export interface ItemFolder {
    id: string;
    title: string;
    slug: string;
    icon: string;
    count?: number;
}
export class ItemPagination {
    length: number = 0;
    size: number = 10;
    page: number = 0;
    lastPage: number = null;
    startIndex: number = null;
    endIndex: number = null;
    orderBy: string = "asc";
    trash: boolean = false;
    orderOn: string = null;
}

export interface IAlert {
    type: string;
    message: string;
    selfClose: boolean;
}

export interface pickerDirectory {
    name: string,
    type: "directory" | "file",
    children?: pickerDirectory[],
    file?: File
}

export interface OversizedFile {
    name: string,
    size: string,
    path: string
}

export interface BaseListReponse {
    data: any[],
    page: number;
    size: number;
    total: number
}

interface AssetNavigation {
    sortOrder: number;
    id: string;
    name: string;
}
export interface AssetListReponse extends BaseListReponse {
    totalFiles: number;
    totalFolders: number;
    navigation: AssetNavigation[];
}

export class assetsFilterFields {
    modified: boolean = true;
    fileType: boolean = true;
    label: boolean = true;
    user:boolean = false;
    starred:boolean = true;
}

export class AssetsSearch{
    account: string=null;
    labels: string[]=null;
    parent: string=null;
    keywords: string=null;
    start: Date=null;
    end: Date=null;
    status: 'TRASH'|'RESTORE'=null;
    fileType: 'DOCUMENT'|' PDF'|' SPREADSHEET'|' IMAGE'|' PRESENTATION'|'AUDIO'|'VIDEO'|' ARCHIVE'|'FOLDER'|'OTHER'|'any' = null;
    assetType: 'FILE'|'FOLDER'|' ROOT' = null;
    sharedWithId: string = null;
    favourite: boolean = null;
    sortColumn: 'ID'|'NAME'|'FOLDER'|'FILE'|'CREATED_DATE'|'UPDATED_DATE'|'FOLDER_NAME'|'FOLDER_CREATED_DATE'|'FOLDER_UPDATED_DATE' = 'NAME';
    sortDirection: 'ASCENDING'|'DESCENDING' = null;
    sharedOnly:boolean = null;
    searchDescendants: boolean = null;
    includeTopShared: boolean = null;
}

export interface SortingPreference {
    viewName: DMSViews,
    sort: Sort;
}

export type DMSViews = 'Home' | 'Recents' | 'Shared' | 'Trashed' | 'Starred';
